export function getTableDataWrapper(fetchApi, getReqData, options = {}) {
  const {
    dataTransfer = data => data,
    dataListTransfer = data => data,
  } = options

  return async function(pageNum, pageSize) {
    try {
      const reqData = {
        pageNum: pageNum,
        pageSize: pageSize,
        ...(getReqData() || {}),
      }
      const { code, data } = await fetchApi(reqData)
      if (code !== 200) {
        throw new Error('code error')
      }

      const dataFixed = dataTransfer(data)

      return {
        tableData: dataListTransfer(dataFixed.list),
        currentPage: dataFixed.pageNum,
        pageSize: dataFixed.pageSize,
        total: dataFixed.total,
      }
    } catch (error) {
      return {
        tableData: [],
        currentPage: 1,
        pageSize: 20,
        total: 0,
      }
    }
  }
}
